/**
 * @fileoverview 分页相关常量配置
 * @description 全局分页配置，包括默认页码、页面大小等
 */

/**
 * 分页配置常量
 */
export const PAGINATION_CONSTANTS = {
  /** 默认当前页 */
  DEFAULT_CURRENT: 1,
  /** 默认页面大小 */
  DEFAULT_PAGE_SIZE: 20,
  /** 页面大小选项 */
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  /** 最大页面大小 */
  MAX_PAGE_SIZE: 1000,
  /** 是否显示总数 */
  SHOW_TOTAL: true,
  /** 是否显示页面大小选择器 */
  SHOW_PAGE_SIZE: true,
  /** 是否显示快速跳转 */
  SHOW_JUMPER: false
}

/**
 * 创建默认分页配置
 * @returns 默认分页配置对象
 */
export const createDefaultPagination = () => ({
  current: PAGINATION_CONSTANTS.DEFAULT_CURRENT,
  pageSize: PAGINATION_CONSTANTS.DEFAULT_PAGE_SIZE,
  total: 0,
  showTotal: PAGINATION_CONSTANTS.SHOW_TOTAL,
  showPageSize: PAGINATION_CONSTANTS.SHOW_PAGE_SIZE,
  showJumper: PAGINATION_CONSTANTS.SHOW_JUMPER,
  pageSizeOptions: PAGINATION_CONSTANTS.PAGE_SIZE_OPTIONS
})

/**
 * 模态框尺寸常量
 */
export const MODAL_SIZE_CONSTANTS = {
  /** 小型模态框 */
  SMALL: '400px',
  /** 中型模态框 */
  MEDIUM: '500px',
  /** 大型模态框 */
  LARGE: '800px',
  /** 超大模态框 */
  XLARGE: '1200px'
}
